<template>
  <w-icon-wrapper
    :height="48"
    :width="48"
    icon-name='work-checkbox-select-all-icon'
    viewBox='0 -960 960 960'
  >
    <path 
      d='M132-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h696q24 0 42 18t18 42v600q0 24-18 42t-42 18H132Zm0-60h696v-600H132v600Zm68-100h200v-80H200v80Zm382-80 198-198-57-57-141 142-57-57-56 57 113 113Zm-382-80h200v-80H200v80Zm0-160h200v-80H200v80Zm-68 420v-600 600Z' 
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCheckboxSelectAll' };
</script>
